export default __webpack_public_path__ + "static/media/geometry-dash.c58bcb22.webp";